import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-loader" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "base-loader__inner" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "base-loader__cube-1" }),
  /*#__PURE__*/_createElementVNode("div", { class: "base-loader__cube-2" })
], -1)
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLoader',
  setup(__props) {

//

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})